module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "navbar navbar-default"
  }, [(!_vm.websiteAvailability.canTakeOrders || !_vm.websiteAvailability.isOpen) ? _c('div', {
    staticClass: "is-closed-alert"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v("\n        We are sorry but we do not take orders at this moment.\n        " + _vm._s(_vm.websiteAvailability.canTakeOrders && !_vm.websiteAvailability.isOpen ? ("Come back please" + (_vm.websiteAvailability.nextOpeningDay ? ' on ' + _vm.websiteAvailability.nextOpeningDay : '') + " at " + (_vm.websiteAvailability.nextOpeningHour)) : '') + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.location && _vm.location.id === 2 && _vm.$route.name !== 'select-location') ? _c('div', {
    staticClass: "info-popup"
  }, [_c('div', {
    staticClass: "info-popup-content"
  }, [_c('closed-location-notice', [_c('div', {
    staticClass: "change-location-link",
    on: {
      "click": _vm.changeLocation
    }
  }, [_vm._v("Change location")])])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('div', {
    staticClass: "responsive-top-cart"
  }, [_c('a', {
    staticClass: "btn-rotate",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.showCart = !_vm.showCart
      }
    }
  }, [_c('span', {
    staticClass: "cart"
  }, [(_vm.cart.length > 0) ? _c('span', {
    staticClass: "cart-counter"
  }, [_vm._v(_vm._s(_vm.cart.length))]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "ti-shopping-cart"
  })]), _vm._v(" "), _c('p', [_vm._v("\n                £" + _vm._s(_vm.getCartTotal.toFixed(2)) + "\n              ")])])]), _vm._v(" "), _c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleMenuVisible = !_vm.toggleMenuVisible
      }
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar bar1"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar bar2"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar bar3"
  })]), _vm._v(" "), _c('router-link', {
    ref: "homepage",
    staticClass: "kf-logo",
    attrs: {
      "to": "/",
      "tag": "a"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/KF-logo-white.png"),
      "alt": "Kungfood Logo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "location"
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "id": "locationName",
      "title": "Change Location"
    },
    on: {
      "click": _vm.changeLocation
    }
  }, [_vm._v(_vm._s(_vm.locationName))])])], 1), _vm._v(" "), _c('div', {
    class: [_vm.toggleMenuVisible ? 'visible' : '', 'navbar-right-menu']
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('router-link', {
    ref: "homepage",
    attrs: {
      "to": "/",
      "tag": "li"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleMenuVisible = false
      }
    }
  }, [_c('a', {
    staticClass: "btn-rotate"
  }, [_c('p', [_vm._v("\n                  Homepage\n                ")])])]), _vm._v(" "), _c('router-link', {
    ref: "menu",
    attrs: {
      "to": "/menu",
      "tag": "li"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleMenuVisible = false
      }
    }
  }, [_c('a', {
    staticClass: "btn-rotate"
  }, [_c('p', [_vm._v("\n                  Menu\n                ")])])]), _vm._v(" "), _c('router-link', {
    ref: "lunchBoxes",
    attrs: {
      "to": "/lunch-boxes",
      "tag": "li"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleMenuVisible = false
      }
    }
  }, [_c('a', {
    staticClass: "btn-rotate"
  }, [_c('p', [_vm._v("\n                  Lunch Boxes\n                ")])])]), _vm._v(" "), _c('router-link', {
    ref: "contact",
    attrs: {
      "to": "/contact",
      "tag": "li"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleMenuVisible = false
      }
    }
  }, [_c('a', {
    staticClass: "btn-rotate"
  }, [_c('p', [_vm._v("\n                  Contact\n                ")])])]), _vm._v(" "), _c('router-link', {
    ref: "profile",
    attrs: {
      "to": "/profile",
      "tag": "li"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleMenuVisible = false
      }
    }
  }, [_c('a', {
    staticClass: "btn-rotate"
  }, [_c('p', [_vm._v("\n                  " + _vm._s(_vm.user ? 'Profile' : 'Sign in') + "\n                ")])])]), _vm._v(" "), _c('li', {
    staticClass: "cart"
  }, [_c('a', {
    staticClass: "btn-rotate",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.showCart = !_vm.showCart
      }
    }
  }, [_c('span', {
    staticClass: "cart"
  }, [(_vm.cart.length > 0) ? _c('span', {
    staticClass: "cart-counter"
  }, [_vm._v(_vm._s(_vm.cart.length))]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "ti-shopping-cart"
  })]), _vm._v(" "), _c('p', [_vm._v("\n                  £" + _vm._s(_vm.getCartTotal.toFixed(2)) + "\n                ")])])])], 1)])]), _vm._v(" "), _c('CartPopup', {
    attrs: {
      "show-cart": _vm.showCart
    },
    on: {
      "closeShowCart": _vm.closeShowCart
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5c134551!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layouts/TopNavbar.vue
// module id = 556
// module chunks = 1